import { useLang } from "../i18n/LanguageContext";
import { useFlow } from "../context/FlowContext";

const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

export const Footer = () => {
  const { t } = useLang();
  const { openClient } = useFlow();
  const year = new Date().getFullYear();
  const links = [
    { action: () => scrollTo("hero"), label: t.footer.links.home },
    { action: () => scrollTo("how"), label: t.footer.links.how },
    { action: () => scrollTo("what"), label: t.footer.links.what },
    { action: () => scrollTo("pros"), label: t.footer.links.pros },
    { action: () => { window.location.href = "/profesionales"; }, label: t.publicPro.directoryTitle },
    { action: () => openClient(), label: t.footer.links.help },
  ];
  return (
    <footer className="bg-white border-t border-line pt-20 pb-10" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid md:grid-cols-2 gap-12">
          <div>
            <div className="flex items-center gap-2 font-heading font-extrabold text-2xl tracking-tight text-ink">
              <span className="w-2.5 h-2.5 rounded-full bg-forest inline-block" /> HomeHealthy
            </div>
            <p className="mt-4 text-ink-soft max-w-sm leading-relaxed">{t.footer.tagline}</p>
            <p className="mt-3 text-sm text-ink-faint">Madrid · España</p>
          </div>
          <div className="md:justify-self-end">
            <nav className="grid grid-cols-2 gap-x-12 gap-y-3">
              {links.map((l, i) => (
                <button key={i} onClick={l.action} className="text-left text-ink-soft hover:text-forest transition-colors duration-300 font-medium" data-testid={`footer-link-${i}`}>{l.label}</button>
              ))}
            </nav>
          </div>
        </div>
        <div className="mt-16 pt-8 border-t border-line flex flex-col md:flex-row items-center justify-between gap-4">
          <span className="text-sm text-ink-faint">© {year} HomeHealthy. {t.footer.rights}</span>
          <nav className="flex items-center gap-5 text-sm">
            <a href="/privacidad" className="text-ink-faint hover:text-forest transition-colors" data-testid="footer-privacy">Privacidad</a>
            <a href="/terminos" className="text-ink-faint hover:text-forest transition-colors" data-testid="footer-terms">Términos</a>
            <a href="/cookies" className="text-ink-faint hover:text-forest transition-colors" data-testid="footer-cookies">Cookies</a>
          </nav>
        </div>
        <div className="mt-10 select-none pointer-events-none overflow-hidden">
          <span className="block font-heading font-extrabold tracking-tighter text-[18vw] leading-none text-cream-deep text-center">HomeHealthy</span>
        </div>
      </div>
    </footer>
  );
};
